import React, { FC } from 'react';
import { CloseButtonProps } from 'types';
import * as S from './styles';

export const CloseButton: FC<CloseButtonProps> = props => {
	const { color } = props;
	return (
		<S.CloseButton className="close-btn" {...props}>
			<svg width="32" height="32" viewBox="0 0 32 32" fill="none">
				<path
					d="M2.06412 2.06006L30.3484 30.3443M1.6499 30.3443L29.9342 2.06006"
					stroke={color}
					strokeWidth="4"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</S.CloseButton>
	);
};

CloseButton.defaultProps = {
	background: 'transparent',
	color: '#000000',
	elevation: 2,
};

export default CloseButton;
